import { Info } from "lucide-react";
import React, { ReactNode } from "react";

import {
  Checkbox,
  CheckboxProps,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  TextField,
  TypographyProps,
} from "@mui/material";
import { styled } from "@mui/material/styles";

import { IgTooltip } from "./IgTooltip";
import { IgTypography } from "./IgTypography";
import {
  IgBorderColors,
  IgCoreBackgroundColors,
  IgCustomTheme,
  IgIconColors,
} from "./theme";

type IgCheckboxProps = CheckboxProps & {
  // children?: React.ReactNode;
  label?: ReactNode;
  labelProps?: TypographyProps;
};

/**
 * @see Checkbox
 */
export const IgCheckbox = (props: CheckboxProps) => {
  return <Checkbox {...props} />;
};
